<template>
    <component :is="componentName" :type="type"></component>
</template>

<script>
import {mapGetters} from 'vuex';
import articleThemeOne from './theme-one.vue';
import articleThemeTwo from './theme-two.vue';

export default {
    name: 'guideArticle',
    props: {
        type: String,
        default: ''
    },
    components: {
        articleThemeOne,
        articleThemeTwo
    },
    computed: {
        ...mapGetters('guide', ['guide']),
        componentName() {
            if(this.guide.article && this.guide.article.theme == 2) {
                return 'articleThemeTwo';
            }
            return 'articleThemeOne';
        }
    }
};
</script>
